import type { Rating } from '@ctct/domain-layer';

/**
 * Formats today's total amount from a Rating object.
 * @param rating - The Rating object containing the amount to charge
 * @returns Formatted price string (e.g., "$123.45")
 */
export const formatTodaysTotal = (rating?: Rating): string => {
  return !rating ? '' : rating.getAmountToCharge().format(rating.getCurrency());
};
